(function () {
  'use strict';

  var TIME_ZONE = 'America/Toronto';
  var CUTOFF_HOUR = 12;

  function intDays(value) {
    if (value === null || value === undefined || String(value).trim() === '') return null;
    var n = parseInt(value, 10);
    return Number.isFinite(n) && n >= 0 ? n : null;
  }

  function torontoNow() {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date());
    var p = {};
    parts.forEach(function (x) { if (x.type !== 'literal') p[x.type] = parseInt(x.value, 10); });
    return { date: new Date(p.year, p.month - 1, p.day), hour: p.hour, minute: p.minute };
  }

  function ymd(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }

  function nthWeekday(year, month, weekday, nth) {
    var d = new Date(year, month, 1);
    var add = (weekday - d.getDay() + 7) % 7 + (nth - 1) * 7;
    return new Date(year, month, 1 + add);
  }

  function lastWeekdayBefore(year, month, day, weekday) {
    var d = new Date(year, month, day - 1);
    while (d.getDay() !== weekday) d.setDate(d.getDate() - 1);
    return d;
  }

  function easterSunday(year) {
    var a = year % 19, b = Math.floor(year / 100), c = year % 100;
    var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31) - 1;
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(year, month, day);
  }

  function observedFixed(year, month, day) {
    var d = new Date(year, month, day);
    if (d.getDay() === 6) d.setDate(d.getDate() + 2);
    else if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    return d;
  }

  function holidaySet(year) {
    var dates = [];

    // Complete Cycles uses the UNION of Ontario + Quebec holiday closures.
    // We intentionally err on the conservative side for dispatch estimates:
    // if a day can reasonably be a holiday/closure in either province, we
    // do not count it as a fulfillment business day.

    dates.push(observedFixed(year, 0, 1));                         // New Year's Day (ON + QC)
    dates.push(nthWeekday(year, 1, 1, 3));                        // Family Day (Ontario)

    var easter = easterSunday(year);
    var goodFriday = new Date(easter);
    goodFriday.setDate(easter.getDate() - 2);
    dates.push(goodFriday);                                       // Good Friday (ON; QC may observe)

    var easterMonday = new Date(easter);
    easterMonday.setDate(easter.getDate() + 1);
    dates.push(easterMonday);                                     // Easter Monday (QC may observe instead)

    dates.push(lastWeekdayBefore(year, 4, 25, 1));                // Victoria Day / National Patriots' Day

    // Quebec National Holiday / Saint-Jean-Baptiste Day.
    // Use a Monday observance when June 24 falls on a weekend so the ETA
    // stays conservative around substitute-day closures.
    dates.push(observedFixed(year, 5, 24));                        // June 24 (Quebec)

    dates.push(observedFixed(year, 6, 1));                         // Canada Day (ON + QC)
    dates.push(nthWeekday(year, 7, 1, 1));                        // Civic Holiday (Ontario common closure)
    dates.push(nthWeekday(year, 8, 1, 1));                        // Labour Day (ON + QC)
    dates.push(observedFixed(year, 8, 30));                        // National Day for Truth and Reconciliation
    dates.push(nthWeekday(year, 9, 1, 2));                        // Thanksgiving (ON + QC)
    dates.push(observedFixed(year, 10, 11));                       // Remembrance Day / common carrier closure

    // Christmas / Boxing Day. Ontario recognizes both; using both gives a
    // safe combined ON/QC dispatch calendar. Handle weekend substitute days
    // without double-counting the same weekday.
    var christmas = new Date(year, 11, 25);
    var boxing = new Date(year, 11, 26);
    if (christmas.getDay() === 6) {
      dates.push(new Date(year, 11, 27));
      dates.push(new Date(year, 11, 28));
    } else if (christmas.getDay() === 0) {
      dates.push(new Date(year, 11, 27));
      dates.push(new Date(year, 11, 26));
    } else {
      dates.push(christmas);
      if (boxing.getDay() === 6) dates.push(new Date(year, 11, 28));
      else if (boxing.getDay() === 0) dates.push(new Date(year, 11, 27));
      else dates.push(boxing);
    }

    var out = {};
    dates.forEach(function (d) { out[ymd(d)] = true; });
    return out;
  }

  function isBusinessDay(d) {
    var weekday = d.getDay();
    if (weekday === 0 || weekday === 6) return false;
    return !holidaySet(d.getFullYear())[ymd(d)];
  }

  function nextBusinessDay(d) {
    var x = new Date(d);
    do { x.setDate(x.getDate() + 1); } while (!isBusinessDay(x));
    return x;
  }

  function dispatchDate(days) {
    var now = torontoNow();
    var d = new Date(now.date);
    var afterCutoff = now.hour >= CUTOFF_HOUR;

    // Orders placed at/after 12:00 PM ET get one additional business day.
    // Example: a 2-business-day item ordered after noon is treated as 3 business days.
    var effectiveDays = days + (afterCutoff ? 1 : 0);

    if (!isBusinessDay(d)) {
      while (!isBusinessDay(d)) d.setDate(d.getDate() + 1);
    }

    if (effectiveDays <= 1) return d;
    var counted = 1;
    while (counted < effectiveDays) {
      d = nextBusinessDay(d);
      counted++;
    }
    return d;
  }

  function formatDate(d) {
    return d.toLocaleDateString('en-CA', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
  }

  function render(el, days) {
    var n = intDays(days);
    if (!el || n === null) return false;
    var date = el.querySelector('[data-dispatch-date]');
    if (date) date.textContent = formatDate(dispatchDate(n));
    el.classList.remove('is-hidden');
    return true;
  }

  function initProduct() {
    var box = document.getElementById('ProductFulfillment');
    if (!box) return;
    function update(value, available) {
      var n = intDays(value);
      if (!available || n === null) { box.classList.add('is-hidden'); return; }
      render(box, n);
    }
    var select = document.getElementById('VariantSelect');
    if (select) {
      select.addEventListener('change', function () {
        var o = this.options[this.selectedIndex];
        update(o.dataset.fulfillmentDays, o.dataset.available === 'true');
      });
      var o = select.options[select.selectedIndex];
      if (o) update(o.dataset.fulfillmentDays, o.dataset.available === 'true');
    } else {
      update(box.dataset.days, box.dataset.available === 'true');
    }
  }

  function initCart() {
    var rows = document.querySelectorAll('[data-cart-fulfillment-days]');
    var maxDays = null;
    rows.forEach(function (row) {
      var n = intDays(row.dataset.cartFulfillmentDays);
      if (n === null) return;
      if (maxDays === null || n > maxDays) maxDays = n;
    });
    var overall = document.getElementById('CartOrderFulfillment');
    var attributeInput = document.getElementById('EstimatedDispatchAttribute');

    if (overall && maxDays !== null) {
      var calculatedDate = dispatchDate(maxDays);
      render(overall, maxDays);
      var detail = overall.querySelector('[data-dispatch-detail]');
      if (detail) detail.textContent = 'Based on the longest item lead time in your cart (' + maxDays + ' business day' + (maxDays === 1 ? '' : 's') + ').';

      // Save the exact customer-facing date as a cart attribute. The hidden
      // input is populated synchronously so a normal cart form submission sends
      // the value even if the customer clicks CHECKOUT immediately.
      if (attributeInput) {
        var etaValue = formatDate(calculatedDate);
        attributeInput.value = etaValue;
        attributeInput.dataset.etaReady = 'true';

        // Also persist immediately so alternative checkout paths inherit it.
        fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ attributes: { 'Estimated dispatch': etaValue } })
        }).catch(function () {});
      }
    } else if (attributeInput) {
      attributeInput.value = '';
      attributeInput.dataset.etaReady = 'true';
    }

    // CHECKOUT must not outrun the Ajax persistence call. Intercept only the
    // checkout submit, save the attribute, then navigate to Shopify checkout.
    var cartForm = document.getElementById('CartForm');
    if (cartForm && !cartForm.dataset.etaCheckoutBound) {
      cartForm.dataset.etaCheckoutBound = 'true';
      cartForm.addEventListener('submit', function (event) {
        var submitter = event.submitter;
        if (!submitter || submitter.name !== 'checkout') return;

        event.preventDefault();
        var etaValue = attributeInput ? attributeInput.value : '';
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

        fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ attributes: { 'Estimated dispatch': etaValue } })
        }).then(function (response) {
          if (!response.ok) throw new Error('Unable to save dispatch ETA');
          return response.json();
        }).then(function () {
          window.location.assign(root + 'checkout');
        }).catch(function () {
          // Fallback to a normal form submission. Because the hidden attribute
          // input is already populated, Shopify still receives the ETA.
          var fallback = document.createElement('input');
          fallback.type = 'hidden';
          fallback.name = 'checkout';
          fallback.value = 'Checkout';
          cartForm.appendChild(fallback);
          HTMLFormElement.prototype.submit.call(cartForm);
        });
      });
    }
  }

  window.CompleteCyclesDispatch = { render: render, dispatchDate: dispatchDate, intDays: intDays };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initProduct(); initCart(); });
  else { initProduct(); initCart(); }
})();
